/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取应用列表(启用)
   */
  getAppList: 'GET /app/list',
  /**
   * 获取应用列表(所有(管理端))
   */
  queryAppList: 'GET /app/query'
}
